import { useQuery } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useUserToken } from "@/context/auth-context";
import { useUser } from "@/context/user-context";
import { authHeader } from "@/utils/headers";

interface WorkflowReleaseLabelsResponse {
  success: boolean;
  workflow_id: number;
  static_labels: StaticLabel[];
  dynamic_release_labels: DynamicReleaseLabel[];
}

interface StaticLabel {
  id: number;
  name: string;
  workflow_version_id: number;
  created_at: string | null;
}

interface DynamicReleaseLabel {
  workflow_label_name: string;
  release_label_group_id: number;
  labels: DynamicLabel[];
}

interface DynamicLabel {
  workflow_version_id: number;
  workflow_version_number: number;
  percentage: number;
  is_real_label: boolean;
}

const useGetWorkflowReleaseLabels = (workflowId?: number, enabled?: boolean) => {
  const workspaceId = useUser()?.activeWorkspaceId || 0;
  const userToken = useUserToken();
  return useQuery<WorkflowReleaseLabelsResponse>({
    queryKey: ["workflow-release-labels", workspaceId, workflowId],
    queryFn: async () => {
      const response = await fetch(
        ENDPOINTS.get_workflow_release_labels(workspaceId, Number(workflowId)),
        {
          method: "GET",
          headers: authHeader(userToken),
        },
      );

      if (!response.ok) {
        throw new Error("Failed to fetch workflow release labels");
      }

      const data = await response.json();
      return data;
    },
    enabled: enabled ?? (!!workspaceId && !!workflowId),
  });
};

export default useGetWorkflowReleaseLabels;
